export const products = [
    {

        id: 1,
        img: 'https://www.freeimages.com/photo/school-children-in-india-1438455',
        link: 'https://relaxed-dijkstra-bb0497.netlify.app/',
    },

    {

        id: 2,
        img: 'https://www.freeimages.com/photo/fitness-1476970',
        link: 'https://the-indian-gym.web.app/',
    },

    {

        id: 3,
        img: 'https://www.freeimages.com/photo/fitness-1476970',
        link: 'https://the-indian-gym.web.app/',
    },

    {

        id: 4,
        img: 'https://www.freeimages.com/photo/fitness-1476970',
        link: 'https://the-indian-gym.web.app/',
    },

    {

        id: 5,
        img: 'https://www.freeimages.com/photo/fitness-1476970',
        link: 'https://the-indian-gym.web.app/',
    },

    {

        id: 6,
        img: 'https://www.freeimages.com/photo/fitness-1476970',
        link: 'https://the-indian-gym.web.app/'
    }


    // {

    //     id: 3,
    //     img: '',
    //     link: '',
    // },

    // {

    //     id: 4,
    //     img: '',
    //     link: '',
    // },

    // {

    //     id: 5,
    //     img: '',
    //     link: '',
    // },

    // {

    //     id: 6,
    //     img: '',
    //     link: '',
    // },
]